"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreloadScene = void 0;
var GameManager_1 = require("../GameManager");
var GameVars_1 = require("../GameVars");
var AudioManager_1 = require("../AudioManager");
var Background_1 = require("./Background");
var PreloadScene = /** @class */ (function (_super) {
    __extends(PreloadScene, _super);
    function PreloadScene() {
        return _super.call(this, "PreloadScene") || this;
    }
    PreloadScene.prototype.preload = function () {
        this.composeScene();
        this.loadAssets();
    };
    PreloadScene.prototype.create = function () {
        PreloadScene.currentInstance = this;
        GameManager_1.GameManager.setCurrentScene(this);
        this.loadHowl();
    };
    PreloadScene.prototype.composeScene = function () {
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Baloo", fontSize: "26px", color: "#FFFF00" });
        var background = new Background_1.Background(this);
        this.add.existing(background);
        this.scaledItemsContainer = this.add.container(GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.isDesktop ? .725 * GameVars_1.GameVars.gameHeight : .625 * GameVars_1.GameVars.gameHeight);
        this.scaledItemsContainer.scaleY = GameVars_1.GameVars.scaleY;
        var titleBackground = new Phaser.GameObjects.Image(this, 0, -190, "texture_atlas_0", "title_cookie_base");
        this.scaledItemsContainer.add(titleBackground);
        var title = new Phaser.GameObjects.Image(this, 0, -240, "texture_atlas_0", "title_merge_cakes");
        this.scaledItemsContainer.add(title);
        this.barContainer = new Phaser.GameObjects.Container(this);
        this.barContainer.setScale(.85);
        this.scaledItemsContainer.add(this.barContainer);
        var containerFrame = new Phaser.GameObjects.Image(this, 0, 0, "texture_atlas_0", "lvl_bar");
        containerFrame.setScale(.965);
        this.barContainer.add(containerFrame);
        var leftBarTip = new Phaser.GameObjects.Image(this, -192, 0, "texture_atlas_0", "lvl_bar_fill_end");
        leftBarTip.scaleX = -1;
        leftBarTip.setOrigin(0, .5);
        this.barContainer.add(leftBarTip);
        this.bar = new Phaser.GameObjects.Image(this, -200, 0, "texture_atlas_0", "lvl_bar_fill");
        this.bar.setOrigin(0, .5);
        this.bar.scaleX = 0;
        this.barContainer.add(this.bar);
        this.rightBarTip = new Phaser.GameObjects.Image(this, this.bar.x + this.bar.width * this.bar.scaleX, 0, "texture_atlas_0", "lvl_bar_fill_end");
        this.rightBarTip.setOrigin(0, .5);
        this.barContainer.add(this.rightBarTip);
    };
    PreloadScene.prototype.loadAssets = function () {
        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.atlas("texture_atlas_2", "assets/texture_atlas_2.png", "assets/texture_atlas_2.json");
        if (GameVars_1.GameVars.gameData.tutorialPhase !== 1) {
            this.load.atlas("texture_atlas_3", "assets/texture_atlas_3.png", "assets/texture_atlas_3.json");
        }
        this.load.json("game-text", "assets/config/text.json");
        this.load.json("cakes-names", "assets/config/names.json");
        this.load.json("achievements", "assets/config/achievements.json");
        // audio
        this.load.json("audiosprite", "assets/audio/audiosprite.json");
        this.load.on("progress", this.updateLoadedPercentage, this);
    };
    PreloadScene.prototype.updateLoadedPercentage = function (percentageLoaded) {
        this.bar.scaleX = 13.5 * percentageLoaded;
        this.rightBarTip.x = this.bar.x + this.bar.width * this.bar.scaleX;
    };
    PreloadScene.prototype.loadHowl = function () {
        var json = this.cache.json.get("audiosprite");
        json = JSON.parse(JSON.stringify(json).replace("urls", "src"));
        json = JSON.parse(JSON.stringify(json).replace("../", ""));
        json = JSON.parse(JSON.stringify(json).replace("../", ""));
        AudioManager_1.AudioManager.howl = new Howl(json);
        AudioManager_1.AudioManager.howl.on("load", function () {
            PreloadScene.currentInstance.tweens.add({
                targets: PreloadScene.currentInstance.barContainer,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 500,
                onComplete: function () {
                    GameManager_1.GameManager.onGameAssetsLoaded();
                },
                onCompleteScope: this
            });
        });
    };
    return PreloadScene;
}(Phaser.Scene));
exports.PreloadScene = PreloadScene;
